export const environment = {
  development: true,
  api_url_lambda: "https://o7j76jozh0.execute-api.us-west-1.amazonaws.com/dev/",
  api_url: "https://d36fwfwo4vnk9h.cloudfront.net/",
  // api_url: "http://localhost:3522/",
  frontend_url_backoffice: "https://divineinfinitebeing.influxiq.com/",
  frontend_url: "https://divineinfinitebeing.com/",
  astrology_api_url: "https://json.astrologyapi.com/v1/",
  // new_astrology_api_url: 'https://df6rqy88v6l8f.cloudfront.net',
  new_astrology_api_url: 'https://wczfs5i4xwvt6h3g4z6jgcm4ei0rsvyp.lambda-url.us-east-1.on.aws',
  without_base_url:"https://i526y91jwg.execute-api.us-east-2.amazonaws.com/dev/",
  unauthorized_routes: [
    'user/login',
    'user/build-connection',
    'user-profile/fetch-profile-by-unique-name',
  ],
  confarence_room_base_url:"https://main.d1njtuljco40va.amplifyapp.com",
  positionstack_api_key:'f94b49d3a2592c82286e616abcb1b45d',
  positionstack_api_url:'http://api.positionstack.com/v1/forward',
  image_base_url:'https://all-frontend-assets.s3.amazonaws.com',
  ui_url: 'https://dev.divineinfinitebeing.com/',
  stripe_pub_key:"pk_test_51REPqTBSG7nojY7T0duOxJGy7UCDe4zm1flupxj54SEpDt47wBArjl9H9KxPgIPYkBUF3tvTEKPQxf702ObzhwAE00jacpyAVu",
  environment_name: 'development',
};
